import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../utils/cn';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function NavLink({ to, children, className, onClick }: NavLinkProps) {
  const location = useLocation();
  const isActive = location.pathname === to || (to !== '/' && location.pathname.startsWith(to));

  return (
    <Link
      to={to}
      className={cn(
        "transition-all duration-200",
        isActive 
          ? "text-emerald-200 font-semibold" 
          : "text-emerald-100 hover:text-white",
        className
      )}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}